import {
	basePriceChangeConstants
}from "./constants"
import actions from '../../actions'

const initialState =
{
	isSending : false,
	list      : null,
	paged     : {},
	changed   : null
}

export default function (state = initialState, action){
	switch (action.type){
		case basePriceChangeConstants.GetDateList.REQUEST:
		case basePriceChangeConstants.GetPaged.REQUEST:
		case basePriceChangeConstants.Create.REQUEST:
		case basePriceChangeConstants.Delete.REQUEST:
		case basePriceChangeConstants.Upload.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}

		case basePriceChangeConstants.GetDateList.FAILURE:
		case basePriceChangeConstants.Create.FAILURE:
		case basePriceChangeConstants.Delete.FAILURE:
		case basePriceChangeConstants.GetPaged.FAILURE:
		case basePriceChangeConstants.Upload.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload
			}

		case basePriceChangeConstants.Upload.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.download : null
			}

		case basePriceChangeConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}

		case basePriceChangeConstants.GetDateList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}

		case basePriceChangeConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : 'Цена успешно добавлена!'
			}

		case basePriceChangeConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : 'Цена успешно удалена!'
			}

		case basePriceChangeConstants.CLEAR:
			return {
				isSending : false,
				list      : null,
				paged     : {},
				changed   : null
			}
		default:
			return state
	}
}